import React from 'react';
import '../styles/ScrollDownArrow.css';

const ScrollDownArrow = ({ targetSelector }) => {
  const handleScrollDown = () => {
    const nextSection = document.querySelector(targetSelector);
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <button className="hero-scroll-down" onClick={handleScrollDown} aria-label="Scroll to next section">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 16L20 24L28 16" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </button>
  );
};

export default ScrollDownArrow; 